import { StateSchema } from 'app/config/storeConfig/types';
import { WarehouseMapTool } from '../types';

export const getActiveTool = (state: StateSchema): WarehouseMapTool => state.warehouseMapConstructor.activeTool;
